<template>

  <Form
    :title="$t('Career site')"
    :creating="creating"
    :loading="loading">
    <form
      id="profile-form"
      class="shurt-conatiner"
      v-on:submit.prevent="saveProfile(careersite)">
      <div class="form-group">
        <label>{{ $t('Default image') }}</label>
        <p class="text-muted">{{ $t('Set a default image for your careers site. You can change images for a certain page in page settings.') }}</p>
        <div
          class="mb-3"
          v-if="careersite.cover_media_url">
          <img
            v-bind:src="imageResizeUrl + encodeURIComponent(careersite.cover_media_url)"
            style="max-width: 500px;">
        </div>
        <InputOnePhoto
          v-model="careersite.cover_media_id"
          @input="setFile" />
        <ValidateMessage :error="validateErrors['careersite.cover_media_id']" />
      </div>

      <hr class="my-4">

      <div class="form-group">
        <label>{{ $t('Custom HTML in HEAD') }}</label>
        <p class="text-muted">{{ $t('Custom html (including scripts) attached at the end of the < head > section.') }}</p>
        <TextareaCode v-model="careersite.html_head"></TextareaCode>
        <ValidateMessage :error="validateErrors['careersite.html_head']" />
      </div>

      <div class="form-group">
        <label>{{ $t('Custom HTML in BODY') }}</label>
        <p class="text-muted">{{ $t('Custom html (including scripts) attached at the end of the < body > section.') }}</p>
        <TextareaCode v-model="careersite.html_body"></TextareaCode>
        <ValidateMessage :error="validateErrors['careersite.html_body']" />
      </div>

      <hr class="my-4">

      <h5 class="mb-4">{{ $t('Notifications') }}</h5>

      <div class="form-group mb-4">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="gdpr"
            v-model="careersite.apply_confirm_job_enabled">
          <label
            class="form-check-label"
            for="gdpr">
            Personalizar mensagem de confirmação de candidatura na vaga
            </label>
        </div>
        <ValidateMessage :error="validateErrors['careersite.apply_confirm_job_enabled']" />
        <div v-if="careersite.apply_confirm_job_enabled">
          <div class="mb-3">
            <input 
              type="text" 
              class="form-control mb-1" 
              v-model="careersite.apply_confirm_job_subject" 
              :placeholder="$t('Subject')">
            <ValidateMessage :error="validateErrors['careersite.apply_confirm_job_subject']" />
          </div>
          <div>
            <textarea-editable
              v-model="careersite.apply_confirm_job_body"
              :variables="['[candidate_full_name]', '[candidate_first_name]', '[job_title]']"
              editor-model="html"
              :enable-link="true"
              :enable-img="true">
              </textarea-editable>
            <ValidateMessage :error="validateErrors['careersite.apply_confirm_job_body']" />
          </div>
        </div>
      </div>

      <div class="form-group mb-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="gdpr"
            v-model="careersite.apply_confirm_enabled">
          <label
            class="form-check-label"
            for="gdpr">
            Personalizar mensagem de confirmação de candidatura na base
            </label>
        </div>
        <ValidateMessage :error="validateErrors['careersite.apply_confirm_enabled']" />
        <div v-if="careersite.apply_confirm_enabled">
          <div class="mb-3">
            <input 
              type="text" 
              class="form-control mb-1" 
              v-model="careersite.apply_confirm_subject" 
              :placeholder="$t('Subject')">
            <ValidateMessage :error="validateErrors['careersite.apply_confirm_subject']" />
          </div>
          <div>
            <textarea-editable
              v-model="careersite.apply_confirm_body"
              :variables="['[candidate_full_name]', '[candidate_first_name]']"
              editor-model="html"
              :enable-link="true"
              :enable-img="true">
              </textarea-editable>
            <ValidateMessage :error="validateErrors['careersite.apply_confirm_body']" />
          </div>
        </div>
      </div>

    </form>
    <template slot="actions">
      <button
        :class="{'box-loading': loading}"
        type="submit"
        form="profile-form"
        class="btn btn-primary">
        {{ $t('Save') }}
        </button>
    </template>
  </Form>

</template>

<script>
import config from '@/config'
import Form from '@/components/Form/Form'
import InputOnePhoto from '@/components/Fields/InputOnePhoto'
import TextareaCode from '@/components/Fields/TextareaCode'

export default {
  name: 'AccountCareersite',
  components: {
    Form,
    InputOnePhoto,
    TextareaCode
  },
  data () {
    return {
      creating: true,
      loading: false,
      careersite: {},
      validateErrors: false
    }
  },
  computed: {
    imageResizeUrl () {
      return `${config.modfile_url}image/520x520x0/`
    },
    account () {
      return this.$store.getters.getAccount
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.$store
      .dispatch('getAccountCareersite', this.account._id)
      .then(result => {
        this.careersite = result.careersite
        this.creating = false
      })
    },
    /*
    saveProfile
    */
    saveProfile (data) {
      this.loading = true

      this.$store
      .dispatch('updateAccountCareersite', {
        _id: this.account._id,
        careersite: data
      })
      .then(result => {
        this.careersite = result.careersite
        this.loading = false
        this.validateErrors = {}
      })
      .catch(err => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    setFile
    */
    setFile (media) {
      if (this.careersite.cover_media_id) {
        this.careersite.cover_media_url = media ? media.url : null
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Account/AccountCareersite.vue